// extracted by mini-css-extract-plugin
module.exports = {"sent":"LibrariesTable_sent__1-Wym","link":"LibrariesTable_link__Jt35S"};